import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { InlineLoader } from '../InlineLoader';

export interface AsyncFieldWrapperProps {
  loading: boolean;
  delay?: number;
  className?: string;
  children: React.ReactNode;
}

export function AsyncFieldWrapper({
  loading,
  delay,
  className,
  children,
}: AsyncFieldWrapperProps) {
  const classes = useStyles();

  return (
    <div className={`${classes.root} ${className || ''}`}>
      {children}
      <InlineLoader loading={loading} delay={delay} />
    </div>
  );
}

const useStyles = makeStyles({
  root: {
    position: 'relative',
    width: '100%',
  },
});

export default AsyncFieldWrapper;
